<template>
  <section class="card">
    <h2 class="section-heading">
      {{ t('employerForm.confirmation.title') }}
    </h2>

    <div class="checkbox-group">
      <div class="checkbox-block">
        <label :class="['checkbox-item',{'is-invalid':formErrors.has('confirmation.proposalReadAndUnderstood')}]">
          <input
            type="checkbox"
            v-model="form.proposalReadAndUnderstood"
            @change="clearError('confirmation.proposalReadAndUnderstood')"
          />

          <span>
            {{ t('employerForm.confirmation.description') }}
          </span>
        </label>

        <p
          class="invalid-feedback"
          v-if="formErrors.has('confirmation.proposalReadAndUnderstood')"
        >
          {{ t(formErrors.first('confirmation.proposalReadAndUnderstood')) }}
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import Error from '@/utils/Error';
import { reactive, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({})
  },
  formErrors: {
    type: Object,
    default: reactive(new Error({}))
  }
});

const emit = defineEmits(['update:modelValue', 'removeError']);

const form = reactive({
  proposalReadAndUnderstood: false,
  ...props.modelValue
});

watch(form, (val) => emit('update:modelValue', val), { deep: true });

watch(() => props.modelValue, (v) => {
  Object.assign(form, { proposalReadAndUnderstood: false, ...v });
}, { deep: true, immediate: true });

const clearError = (name) => emit('removeError', name);
</script>
<style scoped>
.checkbox-block {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  padding: 10px 14px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
}
.checkbox-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  line-height: 1.5;
}
.checkbox-block input[type="checkbox"]{
  width: 20px;
  height: 20px;
  min-width: 20px;
  margin-top: 2px; 
  cursor: pointer;
}
</style>